import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';

import { uploadFile } from '../redux/scout/scoutActions';
import PredictResponse from './components/predict-response/PredictResponse';
import {
  getGenieGoData,
  predictGenieGoResponse,
  resetSession,
  generateGenieGoMessages,
  replyGenieGo,
} from '../redux/genie-go/genieGoActions';
import { resetGenieGoParams } from '../redux/genie-go/genieGoReducer';
import GenerateMessages from './components/generate-messages/GenerateMessages';
import CommonPage from '../components/common-page/CommonPage';

import scss from './GenieGo.module.scss';

function GenieGo() {
  const dispatch = useDispatch();
  const { id } = useParams();

  const handlePredictResponse = (values) => {
    dispatch(predictGenieGoResponse({ values, projectId: id }));
  };

  useEffect(() => {
    if (id) {
      dispatch(getGenieGoData({ id }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleResetSession = () => {
      dispatch(resetSession());
    };

    window.addEventListener('beforeunload', handleResetSession);

    return () => {
      window.removeEventListener('beforeunload', handleResetSession);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      dispatch(resetSession());
      dispatch(resetGenieGoParams());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CommonPage className={scss.pageWrapper}>
      <PredictResponse onPredictResponse={handlePredictResponse} />

      <GenerateMessages
        onGenerateMessages={generateGenieGoMessages}
        onReply={replyGenieGo}
        onResetSession={resetSession}
        onFileUpload={uploadFile}
      />
    </CommonPage>
  );
}

export default GenieGo;
